import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { ComponentTypes } from "../../../src/taskpane/config/config";
import { RootState } from "../../../src/taskpane/redux";
import { getItemWebViewUrl, getSPListItemWebUrl } from "../../../src/taskpane/services/GraphService";
import authModule from "../../../utilities/AuthModule";
import { LanguageContext } from "../../../utilities/LocalizationModule";


export function useMenuItem_CurrentLocation(selectedItems: any[], isInOneDrive: boolean) {
  const languageStrings = React.useContext(LanguageContext);

  const workingDirectories = useSelector((state: RootState) => state.workingDirectories?.workingDirectories);
  const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.length > 0 ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1] : null);
  const oneDriveRootDetails = useSelector((state: RootState) => state.workingDirectories.oneDriveRootDetails);
  const allowOpenInSharePoint = useSelector((state: RootState) => (state.user.tenantAllowOpenInSharePoint ?? true) && !state.workingDirectories.workingDirectories?.some(dir => dir?.type === ComponentTypes.Docubird));
  const searchValue = useSelector((state: RootState) => state.contentManagerDirectory?.searchValue?.value);

  const [menuItem_CurrentLocation, setMenuItem_CurrentLocation] = React.useState<IContextualMenuItem>();

  React.useEffect(() => {
    if (!searchValue && selectedItems?.length === 0 && allowOpenInSharePoint) {
      setMenuItem_CurrentLocation(
        {
          key: "openCurrentLocation",
          iconProps: { iconName: !isInOneDrive ? "SharepointLogo" : "OneDriveLogo" },
          text: !isInOneDrive ? `${languageStrings.OpenIn} SharePoint` : `${languageStrings.OpenIn} OneDrive`,
          onClick: openLocationInBrowser
        }
      )
    } else {
      setMenuItem_CurrentLocation(null)
    }
  }, [selectedItems, workingDirectories, currentDirectory, isInOneDrive, searchValue]);

  const openLocationInBrowser = React.useCallback((ev?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, item?: IContextualMenuItem) => {
    (async () => {
      if (isInOneDrive && !currentDirectory.directory) {
        window.open(currentDirectory.webUrl);
      }
      else {
        const driveId = !isInOneDrive ? (!currentDirectory.parentId ? currentDirectory.id : currentDirectory.parentId) : oneDriveRootDetails.driveId;

        let itemId: string;
        if (isInOneDrive) {
          itemId = currentDirectory.id;
        }
        else {
          itemId = currentDirectory.parentId && currentDirectory.id;
        }

        let url: string;
        try {
          if (workingDirectories && workingDirectories.some(x => x.type === ComponentTypes.SharePointList)) {
            if (!itemId && currentDirectory.serverRelativePath) {
              url = new URL(currentDirectory.webUrl).origin + currentDirectory.serverRelativePath;
            }
            else {
              url = await getSPListItemWebUrl(await authModule.getGraphAccessToken(), currentDirectory.siteId, driveId, itemId)
            }
          }
          else {
            url = await getItemWebViewUrl(await authModule.getGraphAccessToken(), driveId, itemId)
          } 
        } catch (error) {
          // Ignore
        }

        if (url) {
          window.open(url);
        }
      }
    })();
  }, [workingDirectories, currentDirectory, isInOneDrive]);

  return {
    menuItem_CurrentLocation
  }

}